import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';
import { ImagingScheduleClient, SaveImagingSchedulesDTO } from 'business/models/Models';

export default class ImagingScheduleService extends BaseService {
  async getImagingSchedules() {
    const imsClient: ImagingScheduleClient = ModelFactory(
      ImagingScheduleClient,
      false,
      true,
    );
    return await imsClient.getImagingSchedules();
  }

  async saveImagingSchedules(saveImagingSchedulesDTO: SaveImagingSchedulesDTO) {
    const imsClient: ImagingScheduleClient = ModelFactory(
      ImagingScheduleClient,
      false,
      true,
    );
    return await imsClient.saveImagingSchedules(saveImagingSchedulesDTO);
  }

  async getCaptureProfiles() {
    const imsClient: ImagingScheduleClient = ModelFactory(
      ImagingScheduleClient,
      false,
      true,
    );
    return await imsClient.getCaptureProfiles();
  }

  async getPlatesToImage() {
    const imsClient: ImagingScheduleClient = ModelFactory(
      ImagingScheduleClient,
      false,
      true,
    );
    return await imsClient.getPlatesToImage();
  }

  async getPlateInspectionsToScore() {
    const imsClient: ImagingScheduleClient = ModelFactory(
      ImagingScheduleClient,
      false,
      true,
    );
    return await imsClient.getPlateInspectionsToScore();
  }

  async getIsImagingScheduleInUse(imagingScheduleId: number) {
    const imsClient: ImagingScheduleClient = ModelFactory(
      ImagingScheduleClient,
      false,
      true,
    );
    return await imsClient.getIsImagingScheduleInUse(imagingScheduleId);
  }

  async getIsImagingScheduleDefault(imagingScheduleId: number) {
    const imsClient: ImagingScheduleClient = ModelFactory(
      ImagingScheduleClient,
      false,
      true,
    );
    return await imsClient.getIsImagingScheduleDefault(imagingScheduleId);
  }
}
